module.exports = __webpack_public_path__ + "static/img/historyShop.2588c4c2.png";